module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-10.c45df616.svg";